import { useHistory, useLocation } from 'react-router-dom';

type FeedbackView = 'PENDING' | 'RECEIVED' | 'SHARED' | 'REQUESTED';

export const useSelectedFeedbackViewFromParam = () => {
  const { search } = useLocation();
  const history = useHistory();
  const selectedFeedbackView = new URLSearchParams(search).get('feedbackView') as FeedbackView;

  const pushFeedbackView = (feedbackView: FeedbackView) => {
    const searchParams = new URLSearchParams(search);
    searchParams.set('feedbackView', feedbackView);
    history.push({
      search: searchParams.toString(),
    });
  };

  const replaceFeedbackView = (feedbackView: FeedbackView) => {
    const searchParams = new URLSearchParams(search);
    searchParams.set('feedbackView', feedbackView);
    history.replace({
      search: searchParams.toString(),
    });
  };

  return {
    selectedFeedbackView,
    pushFeedbackView,
    replaceFeedbackView,
  };
};
